import { useState, useEffect } from 'react';
import { api, getAuthToken } from './lib/api.jsx';
import { LoginScreen } from './pages/Login.jsx';
import { Dashboard } from './pages/Dashboard.jsx';
import { ReverifyModal } from './components/ReverifyModal.jsx';

// La modale de code 2FA vit ICI, au-dessus de tout écran : le tout premier appel
// (`/auth/me`, pendant « Vérification de la session... ») peut déjà la demander
// quand le jeton de 12 h a expiré. Montée seulement dans le tableau de bord, elle
// n'existait pas à ce moment-là et l'appel attendait sans fin (constaté en prod le
// 2026-11-03, au lendemain du passage au 2FA obligatoire).
export function App() {
  return (
    <>
      <AppBody />
      <ReverifyModal />
    </>
  );
}

function AppBody() {
  const [user, setUser] = useState(null);
  const [perms, setPerms] = useState(null);
  const [checking, setChecking] = useState(true);
  const loadPerms = async () => {
    try {
      const p = await api.get('/auth/me/permissions');
      setPerms(
        p || {
          permissions: [],
          isGlobalAdmin: false,
        }
      );
    } catch {
      setPerms({
        permissions: [],
        isGlobalAdmin: false,
      });
    }
  };
  useEffect(() => {
    (async () => {
      if (getAuthToken()) {
        const u = await api.get('/auth/me').catch(() => null);
        if (u) {
          setUser(u);
          await loadPerms();
        }
      }
      setChecking(false);
    })();
  }, []);
  const handleLogin = async (u) => {
    setUser(u);
    await loadPerms();
  };
  if (checking)
    return (
      <div id="loading">
        <div className="spinner" />
        <div>Vérification de la session...</div>
      </div>
    );
  if (!user) return <LoginScreen onLogin={handleLogin} />;
  if (!perms)
    return (
      <div id="loading">
        <div className="spinner" />
        <div>Chargement des permissions...</div>
      </div>
    );
  return <Dashboard user={user} perms={perms} reloadPerms={loadPerms} />;
}
